import type { CSSProperties, ReactNode } from 'react';

import { cx } from './classNames';
import { resolveIconClass } from './icons';

/** Pendant zu `SfButton`. */
export interface ButtonProps {
  children?: ReactNode;
  /** Alternative zu `children` — entspricht `SfButton.Content`. */
  content?: string;
  /** Syncfusion- oder Font-Awesome-Angabe, z. B. `"e-icons e-plus"`. */
  iconClass?: string;
  primary?: boolean;
  flat?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit';
  title?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void | Promise<void>;
}

export function Button(props: ButtonProps) {
  const label = props.content ?? props.children;
  const iconOnly = label === undefined || label === null || label === '';
  const icon = resolveIconClass(props.iconClass);

  return (
    <button
      id={props.id}
      type={props.type ?? 'button'}
      title={props.title}
      style={props.style}
      disabled={props.disabled === true}
      aria-label={iconOnly ? props.title : undefined}
      className={cx(
        'e-btn',
        props.primary === true && 'e-primary',
        props.flat === true && 'e-flat',
        iconOnly && icon !== undefined && 'e-icon-btn',
        props.className,
      )}
      onClick={() => {
        void props.onClick?.();
      }}
    >
      {icon === undefined ? null : (
        <span className={cx('e-btn-icon', 'e-icons', iconOnly && 'e-icon-only', icon)} />
      )}
      {label}
    </button>
  );
}

export default Button;
